<template>
<div class="overlay centered">
    <img src="/assets/img/logo@2x.png" class="logo">
    <h2>We're having some technical difficulties.</h2>
    <span>
        There's been an issue contacting the LeadGenius service. Our team has been
        notified. Please try again later.
    </span>
</div>
</template>
<script>
export default {
    name: 'DownMessage'
}
</script>
